<template>
  <a :href="href" class="resource-tile" @mouseenter="triggerAnimation" @focus="triggerAnimation">
    <div class="tile-outer">
      <div class="tile-inner">
        <div class="tile-content">
          <slot>
            <CmsImg v-if="src" :src="src" ref="tileImage" />
          </slot>
        </div>
      </div>
    </div>
    <h5 data-test="resource-tile-title">{{ title }}</h5>
  </a>
</template>

<script setup lang="ts">
import { ref, Ref, inject } from "vue";
import { debug as d } from "debug";
import { CmsImage } from "../../services/cms/cms-type-definitions";
import CmsImg from "./cms-img.vue";

const debug = d("cs.ResourceTile");

const cmsTileImage = inject("cmsTileImage", null) as Ref<InstanceType<typeof CmsImg> | null> | null;

const props = withDefaults(
  defineProps<{
    title?: string;
    href: string;
    src: string | CmsImage | null | undefined;
  }>(),
  {
    title: "",
    href: "javacript:void(0)",
    src: null,
  },
);

const tileImage = ref<InstanceType<typeof CmsImg> | null>(null);

const triggerAnimation = (): void => {
  if (tileImage.value) {
    tileImage.value.animate(true);
  } else if (cmsTileImage?.value) {
    // This handles special case when a CmsImg component
    // is passed by a parent to this component's <slot>
    cmsTileImage.value?.animate(true);
  } else {
    debug("No tile image found to animate");
  }
};
</script>

<style lang="less">
@import (reference) "../../styles/bootstrap/bootstrap.less";

.resource-tile {
  cursor: pointer;
  display: block;
  color: #444;
  text-decoration: none;
  width: 50%;
  max-width: 250px;
  padding: 15px;

  h5 {
    font-size: 18px;
    margin-top: 0.4em;
    width: 100%;

    @media (max-width: @screen-xs-max) {
      font-size: 16px;
    }
  }

  .tile-outer {
    width: 100%;
    padding-top: 100%;
    position: relative;
  }

  .tile-content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      width: 100%;
    }

    .cms-img {
      width: 100%;
      height: 100%;
    }
  }
}

.record-sleeve-theme .tile-outer {
  background-color: #404040;
  position: relative;
  //padding: 15%;

  .tile-inner {
    position: absolute;
    width: 70%;
    height: 70%;
    left: 15%;
    top: 15%;
    // margin-top: 15%;
    border-radius: 50%;
    background-color: white;
    overflow: hidden;

    .tile-content {
      width: 143%;
      height: 143%;
      margin-left: -21.5%;
      margin-top: -21.5%;
    }
  }
}

.resource-themes-list .resource-tile {
  width: 100%;
}

.strength-item-tile-theme.resource-tile,
.strength-item-tile-theme .resource-tile {
  .tile-outer {
    display: none;
  }

  h5 {
    display: block;
    background-color: #eee;
    text-align: center;
    padding: 15px 0px;
    margin: 0;
    width: 100%;
  }
}

.tile-center {
  .tile-content {
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;
  }
}
</style>
